"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var utils_1 = require("../../utils");
var alignStyle = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  align-items: ", ";\n"], ["\n  align-items: ", ";\n"])), function (props) { return utils_1.ALIGN_ITEMS_MAP[props.align]; });
var alignContentStyle = styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  align-content: ", ";\n"], ["\n  align-content: ", ";\n"])), function (props) { return utils_1.ALIGN_CONTENT_MAP[props.alignContent]; });
var BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var basisStyle = styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  flex-basis: ", ";\n"], ["\n  flex-basis: ", ";\n"])), function (props) { return BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis; });
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this
var directionStyle = function (direction, theme) {
    var styles = [
        styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      min-width: 0;\n      min-height: 0;\n      flex-direction: ", ";\n    "], ["\n      min-width: 0;\n      min-height: 0;\n      flex-direction: ", ";\n    "])), direction === 'row-responsive' ? 'row' : direction)
    ];
    if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
        var breakpoint = theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (breakpoint) {
            styles.push(utils_1.addBreakpoint(breakpoint, "\n            flex-direction: column;\n            flex-basis: auto;\n            justify-content: flex-start;\n            align-items: stretch;\n          ", 'down'));
        }
    }
    return styles;
};
var elevationStyle = styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  box-shadow: ", ";\n"], ["\n  box-shadow: ",
    ";\n"])), function (props) {
    return props.theme.global.elevation[(props.priorTheme || props.theme).dark ? 'dark' : 'light'][props.elevationProp];
});
var FLEX_MAP = {
    true: '1 1',
    false: '0 0',
    grow: '1 0',
    shrink: '0 1'
};
var flexStyle = styled_components_1.css(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  flex: ", ";\n"], ["\n  flex: ", ";\n"])), function (props) { return "" + FLEX_MAP[props.flex] + (props.flex !== true && !props.basis ? ' auto' : ''); });
var fillStyle = function (fillProp) {
    if (fillProp === 'horizontal') {
        return 'width: 100%;';
    }
    if (fillProp === 'vertical') {
        return 'height: 100%;';
    }
    if (fillProp) {
        return "\n      width: 100%;\n      height: 100%;\n    ";
    }
    return undefined;
};
var JUSTIFY_MAP = {
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start'
};
var justifyStyle = styled_components_1.css(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  justify-content: ", ";\n"], ["\n  justify-content: ", ";\n"])), function (props) { return JUSTIFY_MAP[props.justify]; });
var wrapStyle = 'flex-wrap: wrap;';
var borderStyle = function (data, responsive, theme) {
    var styles = [];
    var color = utils_1.normalizeColor((typeof data !== 'string' ? data.color : undefined) || 'border', theme);
    var borderSize = (typeof data !== 'string' ? data.size : undefined) || 'xsmall';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var value = "solid " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    var responsiveValue = breakpoint &&
        breakpoint.borderSize &&
        (breakpoint.borderSize[borderSize] || borderSize) &&
        "solid " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
        styles.push(styled_components_1.css(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["border-", ": ", ";"], ["border-", ": ", ";"])), side, value));
        if (responsiveValue) {
            styles.push(utils_1.addBreakpoint(breakpoint, "border-" + side + ": " + responsiveValue + ";", 'down'));
        }
    }
    else if (side === 'vertical') {
        styles.push(styled_components_1.css(templateObject_9 || (templateObject_9 = tslib_1.__makeTemplateObject(["\n      border-left: ", ";\n      border-right: ", ";\n    "], ["\n      border-left: ", ";\n      border-right: ", ";\n    "])), value, value));
        if (responsiveValue) {
            styles.push(utils_1.addBreakpoint(breakpoint, "\n            border-left: " + responsiveValue + ";\n            border-right: " + responsiveValue + ";\n          ", 'down'));
        }
    }
    else if (side === 'horizontal') {
        styles.push(styled_components_1.css(templateObject_10 || (templateObject_10 = tslib_1.__makeTemplateObject(["\n      border-top: ", ";\n      border-bottom: ", ";\n    "], ["\n      border-top: ", ";\n      border-bottom: ", ";\n    "])), value, value));
        if (responsiveValue) {
            styles.push(utils_1.addBreakpoint(breakpoint, "\n            border-top: " + responsiveValue + ";\n            border-bottom: " + responsiveValue + ";\n          ", 'down'));
        }
    }
    else {
        styles.push(styled_components_1.css(templateObject_11 || (templateObject_11 = tslib_1.__makeTemplateObject(["\n        border: ", ";\n      "], ["\n        border: ", ";\n      "])), value));
        if (responsiveValue) {
            styles.push(utils_1.addBreakpoint(breakpoint, "border: " + responsiveValue + ";", 'down'));
        }
    }
    return styles;
};
var ROUND_MAP = {
    full: '100%'
};
var roundStyle = function (data, responsive, theme) {
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    var styles = [];
    if (typeof data === 'object') {
        var size = ROUND_MAP[data.size] || theme.global.edgeSize[data.size || 'medium'];
        var responsiveSize = breakpoint && breakpoint.edgeSize[data.size] && breakpoint.edgeSize[data.size];
        if (data.corner === 'top') {
            styles.push(styled_components_1.css(templateObject_12 || (templateObject_12 = tslib_1.__makeTemplateObject(["\n        border-top-left-radius: ", ";\n        border-top-right-radius: ", ";\n      "], ["\n        border-top-left-radius: ", ";\n        border-top-right-radius: ", ";\n      "])), size, size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "\n              border-top-left-radius: " + responsiveSize + ";\n              border-top-right-radius: " + responsiveSize + ";\n            ", 'down'));
            }
        }
        else if (data.corner === 'bottom') {
            styles.push(styled_components_1.css(templateObject_13 || (templateObject_13 = tslib_1.__makeTemplateObject(["\n        border-bottom-left-radius: ", ";\n        border-bottom-right-radius: ", ";\n      "], ["\n        border-bottom-left-radius: ", ";\n        border-bottom-right-radius: ", ";\n      "])), size, size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "\n              border-bottom-left-radius: " + responsiveSize + ";\n              border-bottom-right-radius: " + responsiveSize + ";\n            ", 'down'));
            }
        }
        else if (data.corner === 'left') {
            styles.push(styled_components_1.css(templateObject_14 || (templateObject_14 = tslib_1.__makeTemplateObject(["\n        border-top-left-radius: ", ";\n        border-bottom-left-radius: ", ";\n      "], ["\n        border-top-left-radius: ", ";\n        border-bottom-left-radius: ", ";\n      "])), size, size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "\n              border-top-left-radius: " + responsiveSize + ";\n              border-bottom-left-radius: " + responsiveSize + ";\n            ", 'down'));
            }
        }
        else if (data.corner === 'right') {
            styles.push(styled_components_1.css(templateObject_15 || (templateObject_15 = tslib_1.__makeTemplateObject(["\n        border-top-right-radius: ", ";\n        border-bottom-right-radius: ", ";\n      "], ["\n        border-top-right-radius: ", ";\n        border-bottom-right-radius: ", ";\n      "])), size, size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "\n              border-top-right-radius: " + responsiveSize + ";\n              border-bottom-right-radius: " + responsiveSize + ";\n            ", 'down'));
            }
        }
        else if (data.corner) {
            styles.push(styled_components_1.css(templateObject_16 || (templateObject_16 = tslib_1.__makeTemplateObject(["\n        border-", "-radius: ", ";\n      "], ["\n        border-", "-radius: ", ";\n      "])), data.corner, size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "\n              border-" + data.corner + "-radius: " + responsiveSize + ";\n            ", 'down'));
            }
        }
        else {
            styles.push(styled_components_1.css(templateObject_17 || (templateObject_17 = tslib_1.__makeTemplateObject(["\n        border-radius: ", ";\n      "], ["\n        border-radius: ", ";\n      "])), size));
            if (responsiveSize) {
                styles.push(utils_1.addBreakpoint(breakpoint, "border-radius: " + responsiveSize + ";", 'down'));
            }
        }
    }
    else {
        var size = data === true ? 'medium' : data;
        styles.push(styled_components_1.css(templateObject_18 || (templateObject_18 = tslib_1.__makeTemplateObject(["\n      border-radius: ", ";\n    "], ["\n      border-radius: ", ";\n    "])), ROUND_MAP[size] || theme.global.edgeSize[size] || size));
        var responsiveSize = breakpoint && breakpoint.edgeSize[size];
        if (responsiveSize) {
            styles.push(utils_1.addBreakpoint(breakpoint, "border-radius: " + responsiveSize + ";", 'down'));
        }
    }
    return styles;
};
var SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var animationBounds = function (type, size) {
    if (size === void 0) { size = 'medium'; }
    if (type === 'fadeIn') {
        return ['opacity: 0;', 'opacity: 1;'];
    }
    if (type === 'fadeOut') {
        return ['opacity: 1;', 'opacity: 0;'];
    }
    if (type === 'jiggle') {
        var deg = JIGGLE_SIZES[size];
        return ["transform: rotate(-" + deg + "deg);", "transform: rotate(" + deg + "deg);"];
    }
    if (type === 'pulse') {
        return ['transform: scale(1);', "transform: scale(" + PULSE_SIZES[size] + ")"];
    }
    if (type === 'flipIn') {
        return ['transform: rotateY(90deg);', 'transform: rotateY(0);'];
    }
    if (type === 'flipOut') {
        return ['transform: rotateY(0);', 'transform: rotateY(90deg);'];
    }
    if (type === 'slideDown') {
        return ["transform: translateY(-" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
    }
    if (type === 'slideLeft') {
        return ["transform: translateX(" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
    }
    if (type === 'slideRight') {
        return ["transform: translateX(-" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
    }
    if (type === 'slideUp') {
        return ["transform: translateY(" + SLIDE_SIZES[size] + "%);", 'transform: none;'];
    }
    if (type === 'zoomIn') {
        return ["transform: scale(" + (1 - ZOOM_SIZES[size]) + ");", 'transform: none;'];
    }
    if (type === 'zoomOut') {
        return ["transform: scale(" + (1 + ZOOM_SIZES[size]) + ");", 'transform: none;'];
    }
    return [];
};
var normalizeTiming = function (time, defaultTiming) {
    return time && typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var animationEnding = function (type) {
    if (type === 'jiggle') {
        return 'alternate infinite';
    }
    if (type === 'pulse') {
        return 'alternate infinite';
    }
    return 'forwards';
};
var animationObjectStyle = function (animation, theme) {
    var bounds = animationBounds(animation.type, animation.size);
    if (bounds) {
        var animationTransition = styled_components_1.css(templateObject_19 || (templateObject_19 = tslib_1.__makeTemplateObject(["\n      from {\n        ", ";\n      }\n      to {\n        ", ";\n      }\n    "], ["\n      from {\n        ", ";\n      }\n      to {\n        ", ";\n      }\n    "])), bounds[0], bounds[1]);
        var animationSettings = theme.global.animation[animation.type];
        return styled_components_1.css(templateObject_21 || (templateObject_21 = tslib_1.__makeTemplateObject(["", "\n    ", "\n    ", "\n    ", ""], ["", "\n    ",
            "\n    ", "\n    ", ""])), styled_components_1.keyframes(templateObject_20 || (templateObject_20 = tslib_1.__makeTemplateObject(["", ""], ["", ""])), animationTransition), normalizeTiming(animation.duration, (animationSettings ? animationSettings.duration : undefined) || theme.global.animation.duration), normalizeTiming(animation.delay, '0s'), animationEnding(animation.type));
    }
    return styled_components_1.css(templateObject_22 || (templateObject_22 = tslib_1.__makeTemplateObject([""], [""])));
};
var animationItemStyle = function (item, theme) {
    if (!item) {
        return styled_components_1.css(templateObject_23 || (templateObject_23 = tslib_1.__makeTemplateObject([""], [""])));
    }
    if (Array.isArray(item)) {
        return item.reduce(function (style, a, index) { return styled_components_1.css(templateObject_24 || (templateObject_24 = tslib_1.__makeTemplateObject(["", "", " ", ""], ["", "", " ", ""])), style, index > 0 ? ',' : '', animationItemStyle(a, theme)); }, styled_components_1.css(templateObject_25 || (templateObject_25 = tslib_1.__makeTemplateObject([""], [""]))));
    }
    if (typeof item === 'object') {
        return animationObjectStyle(item, theme);
    }
    return animationObjectStyle({ type: item }, theme);
};
var animationAncilaries = function (animation) {
    if (animation.type === 'flipIn' || animation.type === 'flipOut') {
        return 'perspective: 1000px; transform-style: preserve-3d;';
    }
    return '';
};
var animationObjectInitialStyle = function (animation) {
    var bounds = animationBounds(animation.type, animation.size);
    if (bounds) {
        return bounds[0] + " " + animationAncilaries(animation);
    }
    return '';
};
var animationInitialStyle = function (item) {
    if (typeof item === 'string') {
        return animationObjectInitialStyle({ type: item });
    }
    if (Array.isArray(item)) {
        return item
            .map(function (a) { return (typeof a === 'string' ? animationObjectInitialStyle({ type: a }) : animationObjectInitialStyle(a)); })
            .join('');
    }
    if (typeof item === 'object') {
        return animationObjectInitialStyle(item);
    }
    return '';
};
var animationStyle = styled_components_1.css(templateObject_27 || (templateObject_27 = tslib_1.__makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (props) { return styled_components_1.css(templateObject_26 || (templateObject_26 = tslib_1.__makeTemplateObject(["\n    ", "\n    animation: ", ";\n  "], ["\n    ", "\n    animation: ", ";\n  "])), animationInitialStyle(props.animation), animationItemStyle(props.animation, props.theme)); });
var shadowStyle = function (shadow, theme) {
    if (shadow === true) {
        // Boolean of true as could be string
        return "\n      box-shadow: " + theme.box.boxShadow + ";\n    ";
    }
    else {
        return "box-shadow: " + shadow;
    }
};
// NOTE: basis must be after flex! Otherwise, flex overrides basis
exports.StyledBox = styled_components_1.default.div(templateObject_28 || (templateObject_28 = tslib_1.__makeTemplateObject(["\n  display: ", ";\n  box-sizing: border-box;\n  outline: none;\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  display: ", ";\n  box-sizing: border-box;\n  outline: none;\n  ", ";\n  ", "\n  ", "\n  ", "\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) { return (props.displayAs ? props.displayAs : 'flex'); }, function (props) { return !props.basis && 'max-width: 100%;'; }, utils_1.genericStyles, function (props) { return props.heightProp && "height: " + (props.theme.global.size[props.heightProp] || props.heightProp) + ";"; }, function (props) { return props.widthProp && "width: " + (props.theme.global.size[props.widthProp] || props.widthProp) + ";"; }, function (props) { return props.align && alignStyle; }, function (props) { return props.alignContent && alignContentStyle; }, function (props) { return props.background && utils_1.backgroundStyle(props.background, props.theme); }, function (props) { return props.border && borderStyle(props.border, props.responsive, props.theme); }, function (props) { return props.directionProp && directionStyle(props.directionProp, props.theme); }, function (props) { return props.flex !== undefined && flexStyle; }, function (props) { return props.basis && basisStyle; }, function (props) { return props.fillProp && fillStyle(props.fillProp); }, function (props) { return props.justify && justifyStyle; }, function (props) { return props.round && roundStyle(props.round, props.responsive, props.theme); }, function (props) { return props.wrapProp && wrapStyle; }, function (props) { return props.overflowProp && utils_1.overflowStyle(props.overflowProp); }, function (props) { return props.elevationProp && elevationStyle; }, function (props) { return props.animation && animationStyle; }, function (props) { return props.theme.box && props.theme.box.extend; }, function (props) { return props.shadow && shadowStyle(props.shadow, props.theme); });
var gapStyle = function (directionProp, gap, responsive, theme) {
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    var responsiveSize = breakpoint && breakpoint.edgeSize[gap] && breakpoint.edgeSize[gap];
    var styles = [];
    if (directionProp === 'column') {
        styles.push(styled_components_1.css(templateObject_29 || (templateObject_29 = tslib_1.__makeTemplateObject(["\n        height: ", ";\n      "], ["\n        height: ", ";\n      "])), theme.global.edgeSize[gap]));
        if (responsiveSize) {
            styles.push(utils_1.addBreakpoint(breakpoint, "height: " + responsiveSize + ";", 'down'));
        }
    }
    else {
        styles.push("width: " + theme.global.edgeSize[gap] + ";");
        if (responsive && directionProp === 'row-responsive') {
            styles.push(utils_1.addBreakpoint(breakpoint, "\n            width: auto;\n            height: " + responsiveSize + ";\n          ", 'down'));
        }
    }
    return styles;
};
exports.StyledBoxGap = styled_components_1.default.div(templateObject_30 || (templateObject_30 = tslib_1.__makeTemplateObject(["\n  flex: 0 0 auto;\n  ", ";\n"], ["\n  flex: 0 0 auto;\n  ", ";\n"])), function (props) { return props.gap && gapStyle(props.directionProp, props.gap, props.responsive, props.theme); });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;
//# sourceMappingURL=StyledBox.js.map